import { render, staticRenderFns } from "./clientdashboard-profile-teacher.vue?vue&type=template&id=4afd055e&"
import script from "./clientdashboard-profile-teacher.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-profile-teacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports